var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9181 6.98242H40.111L24.9845 25.9009L9.9181 6.98242ZM1.61547 5.81133C7.71429 13.5889 18.9762 28.0029 18.9762 28.0029V46.0205C18.9807 46.8184 19.3008 47.582 19.8665 48.1447C20.4322 48.7073 21.1976 49.0232 21.9954 49.0234H28.0339C28.8318 49.0232 29.5972 48.7073 30.1629 48.1447C30.7286 47.582 31.0486 46.8184 31.0532 46.0205V28.0029C31.0532 28.0029 42.2849 13.5889 48.3837 5.81133C49.9236 3.8293 48.5045 0.976562 45.9986 0.976562H4.00062C1.49466 0.976562 0.0756217 3.8293 1.61547 5.81133Z",
    fill: "#314D7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlue);
export default __webpack_public_path__ + "static/media/filter_blue.057e742a60f1a8209e922f5874f03b98.svg";
export { ForwardRef as ReactComponent };